import React from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { type ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { artifactKeyToUrlMap } from '@app/store/types/artifacts';

import { DetailContent } from '../DetailContent';
import { Video } from '../Video';

import './Detail.scss';

const contentFramerTransition = { type: 'spring', damping: 80, stiffness: 300, mass: 5, restDelta: 0.00001 };
const contentFramerVariants = {
    hidden: {
        opacity: 0,
        transition: {
            duration: 0,
        },
    },
    shown: {
        opacity: 1,
        x: '0',
        transition: {
            ...contentFramerTransition,
            delay: 0.5,
        },
    },
};

interface ArtifactDetailProps {
    active: boolean;
    expanded: boolean;
    muted: boolean;
    artifactType: ArtifactType;
    artifactId?: string;
    videoUrl?: string;
    posterUrl?: string;
}

export function ArtifactDetail({ active, muted, artifactType, videoUrl, posterUrl, expanded }: ArtifactDetailProps) {
    const artifactClassName = `yat-artifacts__detail--${artifactKeyToUrlMap.get(artifactType) || ''}`;

    return (
        <div className={`yat-artifacts__detail ${artifactClassName}`}>
            <Video
                className="yat-artifacts__detail__video"
                artifactType={artifactType}
                active={active}
                muted={muted}
                videoUrl={videoUrl}
                posterUrl={posterUrl}
                autoPlay
            />
            <AnimatePresence>
                {active && expanded && (
                    <motion.div
                        className="yat-artifacts__detail__content"
                        initial="hidden"
                        animate="shown"
                        exit="hidden"
                        variants={contentFramerVariants}
                    >
                        <DetailContent artifactType={artifactType} />
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
